import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DocumentsDialogModule } from '../../components/documents/documents-dialog.module';

import { ChecklistTemplates } from './checklist-templates';

import { EditChecklistTemplatesDialogModule } from '../../components/edit-checklist-templates-dialog/edit-checklist-templates-dialog.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DocumentsDialogModule,
        EditChecklistTemplatesDialogModule,
        MatButtonModule,
        MatIconModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        ChecklistTemplates,
    ],
    exports: [
        ChecklistTemplates
    ]
})
export class ChecklistTemplatesModule { }
